import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DocAlertsConfigFilter from '@web/components/DocAlerts/DocAlertsConfigTab/DocAlertsConfigFilter';
import DocAlertsConfigModal from '@web/components/DocAlerts/DocAlertsConfigTab/DocAlertsConfigModal';
import DocAlertsSection from '@web/components/DocAlerts/DocAlertsConfigTab/DocAlertsConfigSection';
import { trpc } from '@web/lib/trpc';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useState } from 'react';
export var filterDocument = function (data, docFilterSearch) {
    return data.filter(function (doc) {
        var search = docFilterSearch.toLowerCase();
        var isTitleMatch = doc.documentAlertConfigList.some(function (doc) {
            return doc.document.title.toLowerCase().includes(search) ||
                doc.document.slugId.toLowerCase().includes(search);
        });
        return isTitleMatch;
    });
};
var DocAlertsConfigTab = function () {
    var docSearch = useFilters().docSearch;
    var _a = useState(null), documentAlertConfig = _a[0], setDocumentAlertConfig = _a[1];
    var _b = useState(false), isVisibleModel = _b[0], setIsVisibleModal = _b[1];
    var _c = trpc.documentAlertConfig.useQuery(), data = _c.data, refetch = _c.refetch;
    if (!data)
        return null;
    var onDocAlertsConfigModalClose = function () {
        setDocumentAlertConfig(null);
        setIsVisibleModal(false);
    };
    return (_jsxs("div", { children: [_jsx(DocAlertsConfigFilter, { createDocumentAlertConfig: function () { return setIsVisibleModal(true); } }), _jsx(DocAlertsSection, { documentAlertConfigData: filterDocument(data, docSearch || ''), refetch: refetch, setDocumentAlertConfig: function (documentAlertConfig) {
                    setDocumentAlertConfig(documentAlertConfig);
                    setIsVisibleModal(true);
                } }), _jsx(DocAlertsConfigModal, { visible: isVisibleModel, onClose: onDocAlertsConfigModalClose, documentAlertConfig: documentAlertConfig, refetch: refetch }, documentAlertConfig === null || documentAlertConfig === void 0 ? void 0 : documentAlertConfig.id)] }));
};
export default DocAlertsConfigTab;
